module.exports = __webpack_public_path__ + "assets/webgl/ConcreteFloor_Glossiness.1f700d63.jpg";